'use client';

import { c as _c } from "react/compiler-runtime";
import './global.css';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Script from 'next/script';
import { useEffect } from 'react';
import { sendAnalyticsData } from '../utils/analytics';
import { inter, rubik, shyest, sourceSans3 } from './fonts';
export default function RootLayout(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <head><link rel="preconnect" href="https://js-na1.hs-scripts.com" /><link rel="preconnect" href="https://js.hs-banner.com" /><link rel="preconnect" href="https://app.hubspot.com" /><link rel="preconnect" href="https://js.usemessages.com/" /></head>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Script id="hs-script-loader" strategy="afterInteractive" src="//js-na1.hs-scripts.com/48225519.js" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Analytics />;
    t5 = <SpeedInsights />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <html lang="en" className={`${inter.variable} ${rubik.variable} ${sourceSans3.variable} ${shyest.variable}`}>{t2}<body className={rubik.className}>{t3}{children}{t4}{t5}</body></html>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp() {
  sendAnalyticsData("ABLESPACE_PAGE_OPENED", {
    page: "Home"
  });
}